import { render, staticRenderFns } from "./ShiftEditorStartEnd.vue?vue&type=template&id=0bc0d2c6&scoped=true&lang=pug&"
import script from "./ShiftEditorStartEnd.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorStartEnd.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorStartEnd.vue?vue&type=style&index=0&id=0bc0d2c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0d2c6",
  null
  
)

export default component.exports